import {
  ValidationRole,
  VALIDATION_ROLE_LABELS,
  ALLOWED_VALIDATION_ROLES
} from '@/types/approval-flow.types'

export const VALIDATION_ROLE_OPTIONS: { label: string; value: ValidationRole }[] =
  ALLOWED_VALIDATION_ROLES.map((role) => ({
    label: VALIDATION_ROLE_LABELS[role],
    value: role
  }))

export const attributeOptions = [
  { label: 'Modalidade de repasse', value: 'repass_mode' },
  { label: 'Regra de proporcionalidade', value: 'proportionality_rule' },
  { label: 'Jornada de trabalho excepcional', value: 'exceptional_workday' },
  { label: 'Valor acordado', value: 'agreed_value' }
]

export const transferOptions = [
  {
    value: 'fluxo',
    title: 'Fluxo',
    description: 'Pagamento conforme a competência do contrato.'
  },
  {
    value: 'a_vista',
    title: 'À vista',
    description: 'Pagamento no próximo dia útil até o fim do dia.'
  }
]

export const rulesofProportionality = [
  {
    value: 'proporcional_com_limite',
    title: 'Proporcional com limite',
    description: 'Desconto por atraso e/ou saída antecipada, sem pagamento adicional.'
  },
  {
    value: 'proporcional_sem_limite',
    title: 'Proporcional sem limite',
    description:
      'Desconto por atraso e/ou saída antecipada. Com pagamento adicional mediante autorização da supervisão.'
  },
  {
    value: 'integral',
    title: 'Integral',
    description:
      'Pagamento integral do plantão, independente de atraso e/ou saída antecipada. Sem pagamento adicional.'
  }
]
